import { apolloClient as client } from 'src/graphql/client/apollo-client';
import { IntegrationMembersDocument } from 'src/graphql/actions/integration/integrationMembers.query';

export const refetchIntegrationMembers = () => {
  client.cache.evict({ fieldName: 'integrationMembers' });
  client.cache.gc();
  client.refetchQueries({
    include: [IntegrationMembersDocument],
  });
};
